module.exports = __webpack_public_path__ + "images/emoji/bulb.babb6a955cfc11469b5b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bulb.png
// module id = Dojx
// module chunks = 24